import { merge } from "@/utils/object";

export enum Method {
  GET = "GET",
  POST = "POST",
  PUT = "PUT",
  DELETE = "DELETE",
}

interface FetchDataParams {
  url: string;
  token?: string;
  data?: any;
  method?: Method;
  option?: Omit<RequestInit, "method" | "body">;
}

interface FetchResponse<T> {
  status: boolean;
  message: T;
  errorMessage?: string;
}

export async function fetchData<T>({
  url,
  token,
  data,
  option,
  method = Method.GET,
}: FetchDataParams): Promise<T> {
  const { headers, ...customConfig } = option || {};
  const defaultHeaders: HeadersInit = {};

  const isFormData = data instanceof FormData;
  let body = data;

  if (data && !isFormData) {
    defaultHeaders["Content-Type"] = "application/json";
    body = JSON.stringify(data);
  }

  if (token) {
    defaultHeaders["Authorization"] = `Bearer ${token}`;
  }

  const mergedHeaders = merge(defaultHeaders, headers);

  const config: RequestInit = {
    headers: mergedHeaders,
    body,
    method,
    ...customConfig,
  };

  const response = await fetch(url, config);
  const { status, message, errorMessage }: FetchResponse<T> =
    await response.json();

  return status ? message : Promise.reject(errorMessage);
}
